import * as Yup from 'yup'
import { getDateByUserFormat, getMinDate, today } from '../../../../helpers/timeHelper'

export const initialValues = {
  type: { name: '', id: null },
  country: { name: '', id: null },
  city: { name: '', id: null },
  number: '',
  date_of_issue: null,
  date_of_expire: null,
}

export const isGdprCertificateType = (type, certificateTypes) => {
  if (!type) return false
  if (type.is_gdpr === true) return true
  const certificateType = certificateTypes?.find((c) => c.id === type.id)
  return certificateType?.is_gdpr === true
}

export const getValidationSchema = (dateFormat, isGdpr = false) => {
  const baseSchema = {
    type: Yup.object().shape({
      id: Yup.number().required('Field is required').nullable(),
    }),
    country: Yup.object().shape({
      id: Yup.number().required('Field is required').nullable(),
    }),
    city: Yup.object().shape({
      id: Yup.mixed().test('Check city', 'Select city from list', function (value) {
        const { name } = this.parent

        return name ? Boolean(value) : true
      }),
    }),
    date_of_issue: Yup.date()
      .min(getMinDate, dateFormat && `Min date is ${getDateByUserFormat(getMinDate)}`)
      .max(today, `Max date is ${getDateByUserFormat(today)}`)
      .typeError(`Invalid date format, valid - ${dateFormat}`)
      .nullable()
      .required('Field is required'),
    date_of_expire: Yup.date()
      .min(Yup.ref('date_of_issue'), 'Date of expire must be later than date of issue')
      .typeError(`Invalid date format, valid - ${dateFormat}`)
      .nullable(),
  }

  return Yup.object().shape(baseSchema)
}
